export const ROLE = {
    ADMIN : "ADMIN",
    GENERAL : "GENERAL"
}

export const PAYMENTSTATUS = {
    PENDING : "PENDING",
    PAID : "PAID",
    FAILED : "FAILED"
}

export const ORDERSTATUS = {
    PENDING : "PENDING",
    SHIPPED : "SHIPPED",
    DELIVERED : "DELIVERED",
    CANCELLED : "CANCELLED"
}